// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementEmailTemplatesUpdateTagsResult = objectOf({
  desired_state: objectOf({
    string: arrayOf(string),
  }),
  undo_identifier: number,
});
